import { lazy, Suspense } from 'react';
import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';

// Lazy for the same reason as the top-nav credits pill: Add funds pulls in the purchase modals and
// Stripe, which other plans must not load on every page.
const LazyFlexCreditsStatusBanner = lazy(() =>
  import('./flex-credits-status-banner').then((m) => ({ default: m.FlexCreditsStatusBanner })),
);

export function GlobalCreditsStatusBanner() {
  const { account } = useAuth();
  if (!isFlexPlan(account)) return null;

  return (
    <Suspense fallback={null}>
      <LazyFlexCreditsStatusBanner />
    </Suspense>
  );
}
